/** @format */

import { Component, computed, input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { StarRatingNumberPipe } from '../pipes/star-rating-number.pipe';
import { ReviewButtonComponent } from '../review-button/review-button.component';
import { ReviewSecondaryRatingComponent } from '../review-secondary-rating/review-secondary-rating.component';
import { ReviewStarsComponent } from '../review-stars/review-stars.component';
import { ReviewStarsConfiguration } from '../models/review-stars.interface';

@Component({
	selector: 'product-reviews-responsive-rating-summary',
	imports: [
		CommonModule,
		StarRatingNumberPipe,
		ReviewButtonComponent,
		ReviewSecondaryRatingComponent,
		ReviewStarsComponent
	],
	templateUrl: './review-responsive-rating-summary.component.html',
	styleUrl: './review-responsive-rating-summary.component.scss'
})
export class ReviewResponsiveRatingSummaryComponent {
	percentage = input<number>();
	rating = input<number>();
	count = input<number>();
	overallRatingRange = input<number>();
	starsOptions = input<ReviewStarsConfiguration>({
		width: '20px',
		height: '20px'
	});
	writeAReviewLabel = input<string>();
	writeAReviewType = input<string>();
	isDrawer = input<boolean>(false);
	productName = input<string>();
	includeSEO = input<boolean>(false);

	renderSEO = computed(() => this.includeSEO() && this.rating() > 0);
}
